<template>
  <v-navigation-drawer
    app
    clipped
    :expand-on-hover="!DRAWER_STATE"
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :temporary="$vuetify.breakpoint.smAndDown"
    color="primary"
  >
    <v-list dense rounded>
      <v-list-item class="px-0 text-left">
        <v-list-item-avatar>
          <v-img src="@/assets/user.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">Youvendo</v-list-item-title>
          <v-list-item-subtitle>
            {{ user.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list dense shaped>
      <template v-for="(item, i) in items">
        <v-row v-if="item.heading && headings" :key="item.heading" align="center">
          <v-col cols="6" class="py-5">
            <span
              style="padding-left: 32px"
              class="text-body-1 subheader"
              :class="item.heading && DRAWER_STATE ? 'show ' : 'hide'"
            >
              {{ item.heading }}
            </span>
          </v-col>
          <v-col cols="6" class="text-center"></v-col>
        </v-row>
        <v-divider v-else-if="item.divider && dividers" :key="i" dark class="my-4"></v-divider>

        <v-list-group
          v-else-if="
            item.children &&
            ((item.admin && isAdmin) ||
              (item.roles && item.roles.includes(userRole)) ||
              !item.admin)
          "
          :key="item.title + i"
          :value="true"
          :prepend-icon="item.icon"
          color="white"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold flex-grow-1 flex-shrink-1 text-truncate">
                {{ $t(item.title) }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:appendIcon>
            <div class="d-flex align-center justify-center">
              <v-chip
                v-if="item.badge && item.badge.title"
                x-small
                :color="(item.badge && item.badge.color) || 'secondary'"
              >
                {{ (item.badge && $t(item.badge.title)) || '' }}
              </v-chip>
              <v-icon color="white">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-list-item link :to="child.link" v-for="child in item.children" :key="child.title">
            <v-list-item-content class="text-start">
              <div class="d-flex justify-space-between">
                <v-icon>{{ child.icon }}</v-icon>

                <v-list-item-title>{{ $t(child.title) }}</v-list-item-title>
                <div class="d-flex align-center justify-center">
                  <v-chip
                    v-if="child.badge && child.badge.title !== 0"
                    x-small
                    :color="(child.badge && child.badge.color) || 'amber darken-4'"
                  >
                    {{
                      (child.badge && $t(child.badge.title)) ||
                      getUnfulfilledCount(child.id, child.badge)
                    }}
                  </v-chip>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- ((item.admin && isAdmin) || !item.admin) -->
        <v-list-item
          v-else-if="
            item.title &&
            ((item.admin && isAdmin) ||
              (item.roles && item.roles.includes(userRole)) ||
              !item.admin)
          "
          :key="item.title"
          :to="item.link"
          :href="item.href"
          :target="item.target"
          link
          class="text-left"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <div class="d-flex align-center justify-space-between">
              <v-list-item-title class="font-weight-bold">
                {{ $t(item.title) }}
              </v-list-item-title>
              <div class="d-flex align-center justify-center">
                <v-chip
                  v-if="item.badge && item.badge.title"
                  x-small
                  :color="(item.badge && item.badge.color) || 'secondary'"
                >
                  {{ (item.badge && $t(item.badge.title)) || '' }}
                </v-chip>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { countOrdersShopify } from '../../services/shopifyService'
  import { getStoresProtected } from '../../services/storeService'
  import { getCurrentUser, isUserAdmin, getUserRole } from '../../services/authService'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        user: {},
        isAdmin: false,
        userRole: '',
        items: [
          {
            title: 'Home',
            icon: 'mdi-home-outline',
            link: '/',
          },
          {
            id: 'orders',
            title: 'Orders',
            icon: 'mdi-inbox-outline',
            badge: {
              title: 'NEW',
              color: 'amber darken-4',
            },
            children: [],
          },
          {
            id: 'Mizodia',
            title: 'Mizodia Orders',
            admin: true,
            icon: 'mdi-zodiac-scorpio',
            link: '/admin/mizodia-orders',
          },
          {
            id: 'Amazon',
            title: 'Amazon Prime',
            admin: true,
            icon: 'mdi-package-variant',
            link: '/amazon-prime/orders',
          },
          { heading: 'REGISTRY' },
          {
            title: 'Registry Editor',
            icon: 'mdi-star-cog-outline',
            link: '/regedit',
          },
          {
            title: 'Bulk Registry',
            icon: 'mdi-star-box-multiple-outline',
            link: '/bulk',
            admin: true,
          },
          { divider: true },
          { heading: 'STARS' },
          {
            title: 'Star Catalogue',
            icon: 'mdi-archive-star-outline',
            link: '/star-catalogue',
            badge: {
              title: 'BETA',
              color: 'info darken-4',
            },
          },

          { heading: 'CERTIFICATES' },
          {
            title: 'Custom Certificates',
            icon: 'mdi-certificate-outline',
            link: '/cert-generator',
          },
          { divider: true },
          {
            title: 'Skymap',
            icon: 'mdi-weather-night',
            admin: true,
            badge: {
              title: 'BETA',
              color: 'info darken-4',
            },
            children: [
            {
                title: 'Custom Posters',
                icon: 'mdi-circle-small',
                link: '/skymap-products/poster',
              },
              {
                title: 'Custom Jewelry',
                icon: 'mdi-circle-small',
                link: '/skymap-products/jewelry',
              },
            ],
          },
          { divider: true },
          { heading: 'HELP' },
          {
            title: 'Mizodia',
            icon: 'mdi-zodiac-scorpio',
            admin: true,
            roles: ['mizodia'],
            badge: {
              title: 'BETA',
              color: 'info darken-4',
            },
            children: [
              /*               {
                title: 'Orders',
                icon: 'mdi-circle-small',
                link: '/mizodia/orders',
              }, */
              {
                title: 'Manual books',
                icon: 'mdi-circle-small',
                link: '/mizodia/custom',
              },
              {
                title: 'Fingerprint',
                icon: 'mdi-circle-small',
                link: '/mizodia/fingerprints',
              },
              {
                title: 'Custom Print Extractor',
                icon: 'mdi-circle-small',
                link: '/mizodia/print-extractor',
              },
              {
                title: 'Engraving Mask',
                icon: 'mdi-circle-small',
                link: '/mizodia/engraving-mask',
              },
              {
                title: 'Birth Flower Bouquet',
                icon: 'mdi-circle-small',
                link: '/mizodia/birth-flower-bouquet',
              },
            ],
          },
          {
            title: 'Software',
            icon: 'mdi-monitor-cellphone-star',
            href: 'https://software.space-registry.org',
            target: '_blank',
          },

          { title: 'F.A.Q', icon: 'mdi-head-question-outline', link: '/faq' },
        ],
        headings: false,
        dividers: true,
        sidebarWidth: 240,
        sidebarMinWidth: 96,
      }
    },
    async mounted() {
      this.user = getCurrentUser()
      this.isAdmin = await isUserAdmin()
      this.userRole = await getUserRole()

      console.log(this.isAdmin)
      const ordersItem = this.items.find((item) => item.id === 'orders')
      const stores = await getStoresProtected()
      ordersItem.children = stores.map((store) => ({
        id: store.id,
        title: store.domain.replace('www.', ''),
        link: `/admin/orders/${store.id}`,
        icon: 'mdi-circle-small',
        badge: {
          title: '',
          type: 'async',
          color: 'amber darken-4',
        },
      }))
    },
    computed: {
      ...mapState(['drawer']),
      DRAWER_STATE: {
        get() {
          return this.drawer
        },
        set(newValue) {
          if (newValue === this.drawer) return
          // this.TOGGLE_DRAWER() //error::: always giving true value
        },
      },
    },
    methods: {
      ...mapActions(['TOGGLE_DRAWER']),
      getUnfulfilledCount: async function (storeId, item) {
        if (item.title === 0) return 0

        try {
          const { data } = await countOrdersShopify(storeId, 'unfulfilled')
          item.title = data.count
          return data.count
        } catch (error) {
          return 0
        }
      },
    },
  }
</script>

<style lang="scss">
  .v-navigation-drawer {
    top: 64px !important;
    height: calc(100vh - 64px) !important;
    .v-navigation-drawer__content {
      &::-webkit-scrollbar {
        width: 0px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 36px;
        border: none;
      }
    }

    .hide {
      opacity: 0;
    }
    .show {
      opacity: 1;
    }
  }

  .v-navigation-drawer--temporary.v-navigation-drawer--clipped {
    z-index: 5;
  }
</style>
